import { ExportService, FILE_TYPE } from "../ExportService";
import { REPORT_TYPE } from "../../../components/report/ReportModalController";
import {PDF, accounts } from '../../arsweb/RoutingPaths';
import { EXPORT_TYPE } from "../../../components/export/ExportModalController";
import {downloadSettingsValueKey} from "fides-angularjs-components/src/fts-administration/fts-exportDownload-settings/fts-download-settings";

/** @ngInject */
export class PDFService extends ExportService {
    constructor(ArsConfig, userService) {
        super(ArsConfig, userService);
        this.unlimitedElementsReportTypes = [EXPORT_TYPE.PDF_ACCOUNT_OVERVIEW];
    }

    route(controller, reportType) {
        return PDF +
            (this.isGroupUrl(controller.restUrl) || accounts === controller.restUrl ? '' : controller.restUrl) +
            reportType.url;
    }

    /**
     * Download the PDF file
     * @param controller
     * @param selectedElements: omitted when the filter is used (group cases)
     * @returns {*}
     */
    downloadPDF(controller, selectedElements, params) {
        const userSettings = this.sessionPersistance.get(downloadSettingsValueKey);
        const reportType = params.reportType;
        const service = this.getService(controller);
        const body = this.getCommonBody(params.unRead, params.lastStatement, params.withBalance);
        body.emptyPages = userSettings != null ? userSettings.emptyPages === 'SETTINGS_DOWNLOAD_PDF_EMPTY_PAGES_OPTION_A' : true;
        body.translations = this.getTranslations();
        super.constructReportServiceCall(service, params, body);

        if (REPORT_TYPE.PDF_ACTUAL_STATEMENT === reportType || REPORT_TYPE.PDF_ACTUAL_INTRADAY === reportType) {
            selectedElements = [service.service.config.params.id];
        }

        // Group or select all cases: we use a filter to get the items (accounts, statements)
        if (!selectedElements) {
            if(controller.masterRowCount) {
                this.total = controller.masterRowCount;
                body.total = this.total;
                this.download(controller, service, body, reportType);
            } else { // TODO: REMOVE OLD TABLES
                this.checkTotalElements(service, controller.restUrl)
                    .then(() => this.download(controller, service, body, reportType));
            }
            return;
        }

        // Selection cases: we use the selected items for the query
        if (selectedElements.length === 0) {
            controller.infoPop('NO_ROW_SELECTED');
            return;
        }

        body.ids = selectedElements;
        body.total = selectedElements.length;
        controller.promise = service[FILE_TYPE.PDF.userFunction](this.route(controller, reportType), body)
            .then((data) => this.downloadFile(data, body.title, FILE_TYPE.PDF, controller, service, body, reportType));
    }

    download(controller, service, body, reportType){
        controller.promise = service[FILE_TYPE.PDF.userFunction](this.route(controller, reportType), body)
            .then(data => this.downloadFile(data, body.title, FILE_TYPE.PDF, controller, service, body, reportType))
            .then(() => this.resetFilter(controller, service));
    }
}
